module.exports = __webpack_public_path__ + "images/rentalhistory-icon.a55b8c2a063af5c2285e00e86ae8d775.svg";